import get from 'lodash.get';
import {
    GATED_MEASURES_KEY,
    GATING_MEASURE_KEY,
    RULE_TYPE_KEY,
    RULE_TYPES,
} from '../../constants/gatingRules';

class Rule {
    constructor(gatingMeasure, gatedMeasures, ruleType, isRuleMet) {
        this.gatingMeasure = gatingMeasure;
        this.gatedMeasures = gatedMeasures;
        this.ruleType = ruleType;
        this.isRuleMet = isRuleMet;
    }

    /**
     * Method used to set measure as gaint for rule
     * @param {String} measure gaint measure
     */
    setGatingMeasure(measure) {
        this.gatingMeasure = measure;
    }

    /**
     * Method used to set measures as gated for rule
     * @param {Array:String} measures gated measures
     */
    setGatedMeasures(measures) {
        this.gatedMeasures = measures;
    }

    /**
     * Method used to set rule type for rule
     * @param {String} type gated measures
     */
    setRuleType(type) {
        this.ruleType = type;
    }

    /**
     * Method used to determine is rule requrement met
     * @param {Object} gatedMeasures status of gated measures
     */
    setIsRuleMet(gatedMeasures) {
        this.isRuleMet = Object.keys(gatedMeasures).length > 0;
    }

    /**
     * Method used construct rule data based on input parameters
     * @param {Array} ruleDescription rule description received from BE
     * @param {Array} studentResults student's measure results for window
     * @param {Object} gatedMeasuresStatus status of gated measures
     */
    constructRule(ruleDescription, studentResults, gatedMeasuresStatus) {
        this.setGatingMeasure(ruleDescription[GATING_MEASURE_KEY]);
        this.setGatedMeasures(Object.keys(ruleDescription[GATED_MEASURES_KEY]));
        this.setRuleType(RULE_TYPES[ruleDescription[RULE_TYPE_KEY]]);

        const gatingMeasureResult = studentResults.find(
            result =>
                result.isValid &&
                get(result, 'measureScores', {}).hasOwnProperty(this.gatingMeasure),
        );

        if (gatingMeasureResult) {
            this.setIsRuleMet(gatedMeasuresStatus);
        }
    }

    /**
     * Method used to get all rule atributes
     * @return {{gatingMeasure:?string, gatedMeasures:Array, ruleType:?string, isRuleMet:?boolean}}
     */
    getRuleAtributes() {
        return {
            gatingMeasure: this.gatingMeasure,
            gatedMeasures: this.gatedMeasures,
            ruleType: this.ruleType,
            isRuleMet: this.isRuleMet,
        };
    }
}

export default Rule;
